import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Alert,
} from "@mui/material";

interface DeleteMeetingDialogProps {
  open: boolean;
  meetingTitle: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteMeetingDialog: React.FC<DeleteMeetingDialogProps> = ({
  open,
  meetingTitle,
  onClose,
  onConfirm,
}) => {
  const [confirmText, setConfirmText] = React.useState("");
  const requiredText = "end meeting";

  const handleConfirm = () => {
    if (confirmText.toLowerCase() === requiredText) {
      onConfirm();
      setConfirmText("");
    }
  };

  const handleClose = () => {
    setConfirmText("");
    onClose();
  };

  const isConfirmValid = confirmText.toLowerCase() === requiredText;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>End Meeting</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            This action cannot be undone. The meeting will be ended and marked
            as inactive.
          </Alert>

          <Typography variant="body1" sx={{ mb: 2 }}>
            You are about to end the meeting:
          </Typography>

          <Typography
            variant="h6"
            sx={{ mb: 3, fontWeight: "bold", color: "error.main" }}
          >
            {meetingTitle}
          </Typography>

          <Typography variant="body2" sx={{ mb: 1 }}>
            To confirm, please type <strong>{requiredText}</strong> below:
          </Typography>

          <TextField
            fullWidth
            placeholder={requiredText}
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            autoFocus
            error={confirmText.length > 0 && !isConfirmValid}
            helperText={
              confirmText.length > 0 && !isConfirmValid
                ? `Please type "${requiredText}" exactly`
                : ""
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={!isConfirmValid}
        >
          End Meeting
        </Button>
      </DialogActions>
    </Dialog>
  );
};
